module.exports = __webpack_public_path__ + "img/aeroland-contact-form-image-01.8d53290d.png";